import { Box, Flex } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { Button, Heading, colors } from 'ui-components';
import { SupportedPlatforms } from '~/screens/CreatorAudienceDemographics';

import { MockMetrics } from './MockMetrics';

interface Props {
  platform: SupportedPlatforms;
  hasError?: boolean;
  isManager: boolean;
  isBuilder?: boolean;
  isSTMPredicted?: boolean;
  messageToShow?: string;
}
export const EmptyState: React.FC<Props> = ({
  platform,
  isManager,
  hasError = false,
  isBuilder = false,
  isSTMPredicted = false,
  messageToShow = 'Detailed Talent & Channel metrics are not currently available for this Talent. Please try again later.',
}) => {
  const router = useRouter();
  const slug = router.query.creatorSlug as string;

  const navigateToConnections = () => {
    router.push(`/t/${slug}/platform-connections`);
  };

  const getHeadingMessage = () => {
    if (hasError || platform === 'snapchat') return messageToShow;
    if (isSTMPredicted)
      return 'Channel metric estimates are unavailable for this Talent. Invite them to connect to view their verified metrics.';
    return 'Access detailed metrics directly from platform APIs by asking this Talent to connect their social accounts.';
  };

  return (
    <Box position="relative">
      <Flex
        width="100%"
        height="100%"
        position="absolute"
        top={0}
        left={0}
        background={`linear-gradient(transparent,${colors.primary[0]})`}
        alignItems="end"
      >
        <Flex
          maxWidth={708}
          mx="auto"
          justifyContent="center"
          textAlign="center"
          flexDirection="column"
          gap={6}
          py={4}
        >
          <Heading size="sm">{getHeadingMessage()}</Heading>

          {!hasError && isManager && platform !== 'snapchat' && (
            <Box>
              <Button size="md" onClick={navigateToConnections}>
                Connect
              </Button>
            </Box>
          )}
        </Flex>
      </Flex>
      <MockMetrics platform={platform} isBuilder={isBuilder} />
    </Box>
  );
};
